// 数组转树状结构
function getArrayTree (arrList, id, fid, children = 'children') {
  let map = []
  arrList.forEach((item) => {
    let up = arrList.filter((x) => x[id] == item[fid])
    let sit = arrList.filter((x) => x[fid] == item[id])
    if (sit.length) item[children] = sit
    if (!(up.length && !sit.length)) map.push(item)
  })
  if (arrList.length == map.length) return map
  else return getArrayTree(map, id, fid)
}

//时间格式化 yyyy-MM-dd HH:mm:ss
function formatTime(date) {
  var dateee = new Date(date).toJSON()
  return new Date(+new Date(dateee) + 8 * 3600 * 1000)
    .toISOString()
    .replace(/T/g, ' ')
    .replace(/\.[\d]{3}Z/, '')
}


//导出文件，不传文件类型，默认excel
function exportExcelFile(blobData, fileName, fileType) {
  var type = 'application/vnd.ms-excel'
  if (fileType) {
    switch (fileType) {
      case 'word':
        type = 'application/vnd.ms-word'
        break
    }
  }
  const blob = new Blob([blobData], { type: type })
  const downloadElement = document.createElement('a')
  const href = window.URL.createObjectURL(blob) // 创建下载的链接
  downloadElement.href = href
  downloadElement.download = decodeURI(fileName) // 下载后文件名
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}

//特定日期增加月份返回两种格式 0：yyyy-MM-dd 1：yyyy-MM-dd HH:mm:ss
export function commonAddMouth(dateStr, num, type) {
  var monthNum = 0
  if (typeof num == 'string') {
    monthNum = parseInt(num)
  } else {
    monthNum = num
  }
  var date = new Date(dateStr)
  //获取原日
  var day = date.getDate()
  //获取原月份
  var month = date.getMonth()
  //设置增加月份
  date.setMonth(date.getMonth() + monthNum * 1, 1)
  //获取增加的后的月份
  var Jmonth = date.getMonth() + 1
  //获取增加的后的年份
  var Jyear = date.getFullYear()
  if (Jmonth == 4 || Jmonth == 6 || Jmonth == 9 || Jmonth == 11) {
    //小月
    if (day > 30) {
      day = 30
    }
  } else if (Jmonth == 2) {
    //2月判断是否闰年
    if ((Jyear % 4 == 0 && Jyear % 100 != 0) || Jyear % 400 == 0) {
      if (day > 29) {
        day = 29
      }
    }
    if (day > 28) {
      day = 28
    }
  } else {
    //大月
    if (day > 31) {
      day = 31
    }
  }
  var tHours = date.getHours()
  var tMinutes = date.getMinutes()
  var tSeconds = date.getSeconds()
  tHours = tHours < 10 ? '0' + tHours : tHours
  tMinutes = tMinutes < 10 ? '0' + tMinutes : tMinutes
  tSeconds = tSeconds < 10 ? '0' + tSeconds : tSeconds
  Jmonth = doHandleMonth(Jmonth)
  day = doHandleMonth(day)
  if (type == '0') {
    return `${Jyear}-${Jmonth}-${day}`
  }

  return `${Jyear}-${Jmonth}-${day} ${tHours}:${tMinutes}:${tSeconds}`
}

/**
 *  日或月补0
 * @param month
 * @returns {string}
 */
function doHandleMonth(month) {
  var m = month
  if (month.toString().length == 1) {
    m = '0' + month
  }
  return m
}
// 富文本处理
function formatRichText(html) {
  let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
    match = match
      .replace(/style="[^"]+"/gi, "")
      .replace(/style='[^']+'/gi, "");
    match = match
      .replace(/width="[^"]+"/gi, "")
      .replace(/width='[^']+'/gi, "");
    match = match
      .replace(/height="[^"]+"/gi, "")
      .replace(/height='[^']+'/gi, "");
    return match;
  });
  newContent = newContent.replace(
    /style="[^"]+"/gi,
    function (match, capture) {
      match = match
        .replace(/width:[^;]+;/gi, "max-width:100%;")
        .replace(/width:[^;]+;/gi, "max-width:100%;");
      return match;
    }
  );
  // newContent = newContent.replace(/<br[^>]*\/>/gi, "");
  newContent = newContent.replace(
    /\<img/gi,
    '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"'
  );
  return newContent;
}


/**
 * 获取当前年月日
 * @returns {Object} 包含年、月、日的对象，格式为 {year, month, day, formattedDate}
 *                  formattedDate 为 yyyy-MM-dd 格式的日期字符串
 */
function getCurrentDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth() 返回 0-11
  const day = date.getDate();
  
  // 格式化月和日，确保两位数
  const formattedMonth = doHandleMonth(month);
  const formattedDay = doHandleMonth(day);
  
  return {
    year,
    month,
    day,
    formattedDate: `${year}-${formattedMonth}-${formattedDay}`
  };
}


export { getArrayTree, formatTime, exportExcelFile, doHandleMonth, formatRichText, getCurrentDate }
